import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import { browserHistory } from 'react-router';
import moment from 'moment';

const defaultInitialState = {
	discountPartner: '',
	fields: {
		title: '',
		promocode: '',
		description_en: '',
		description_ru: '',
		partner_logo: '',
		discount_terms: []
	}
};

const createForm = ({ namespace, stateNodeName }) => {
	// action types
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-success`;

	const FORM_TEXT_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-text-submit-success`;
	const FORM_TEXT_SUBMIT_ERROR = `${namespace}/${stateNodeName}-text-submit-error`;

	const FORM_IMAGE_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-image-submit-success`;
	const FORM_IMAGE_SUBMIT_ERROR = `${namespace}/${stateNodeName}-image-submit-error`;

	const DISCOUNT_PARTNER_IMAGE_UPLOAD = `${namespace}/${stateNodeName}-image-upload`;

	const TOGGLE_PROGRESS_BAR = `${namespace}/${stateNodeName}-toggle-progress-bar`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		formSubmit: (formData, props) => (dispatch, getState) => {
			const id = props.params && props.params.id;
			return actions.submitFormFields(formData, id)(dispatch, getState)
				.then(discountInserted => {
					const { id } = discountInserted.payload.data;
					return actions.submitFormImage(id)(dispatch, getState);
				})
				.then(() => {
					dispatch({type: FORM_SUBMIT_SUCCESS});
					browserHistory.push('discounts/');
				});
		},
		submitFormFields: (formData, id) => (dispatch, getState) => {
			const formDataToSend = {
				...formData,
				discounts_end_at: formData.discounts_end_at ?
					moment(formData.discounts_end_at, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
			};
			formDataToSend.partner_logo && (delete formDataToSend.partner_logo);
			let endpoint = `${endpoints.DISCOUNTS.BASE}`;
			if (id) {
				endpoint = `${endpoints.DISCOUNTS.SINGLE}`.replace('{id}', id);
			}

			return http({
				url: endpoint,
				method: id ? 'put' : 'post',
				data: formDataToSend,
				actions: [FORM_TEXT_SUBMIT_SUCCESS, FORM_TEXT_SUBMIT_ERROR]
			})(dispatch);
		},
		submitFormImage: id => (dispatch, getState) => {
			const partner_logo = getState().discountsEdit.discountPartner;
			return partner_logo && http({
				url: `${endpoints.DISCOUNTS.BASE_IMAGE.replace('{id}', id)}`,
				method: 'post',
				data: partner_logo,
				actions: [FORM_IMAGE_SUBMIT_SUCCESS, FORM_IMAGE_SUBMIT_ERROR]
			})(dispatch);
		},
		preparationFile: (file, nextAction) => dispatch => {
			const reader = new FileReader();
			const data = new FormData();

			data.append('partner_logo', file);

			reader.readAsDataURL(file);
			reader.onloadend = function () {
				nextAction(reader.result);
				dispatch({
					type: DISCOUNT_PARTNER_IMAGE_UPLOAD,
					payload: data
				});
			};
		}

	};

	// reducers
	const reducers = {
		[FORM_SUBMIT_SUCCESS]: state => ({ ...state, form: initialState }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[DISCOUNT_PARTNER_IMAGE_UPLOAD]: (state, action) => ({...state, discountPartner: action.payload})
	};

	// selectors
	const selectors = {
		getFormData: state => {
			return state;
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/discounts/components/form/index.js